import type { FC } from 'react';
import { CLOUD_LICENSING_PAGE_PATH } from 'utils/pageGating/cloudLicensingPageGating';
import { BreakdownSection } from './BreakdownSection';
import { DeviceTypeBreakdownChart } from './DeviceTypeBreakdownChart';
import { NoBreakdownData } from './NoBreakdownData';
import { type OverviewRow, toDeviceBreakdown } from './licenseBreakdownData';
import { useChartPalette } from './licenseChartPalette';

export type DeviceBreakdownPanelProps = {
  /** Every overview row; the Device category is picked out here. */
  rows: OverviewRow[];
};

export const DeviceBreakdownPanel: FC<DeviceBreakdownPanelProps> = ({
  rows,
}) => {
  const palette = useChartPalette();
  const breakdown = toDeviceBreakdown(rows, palette.device);

  return (
    <BreakdownSection
      title='Device type breakdown'
      detailPath={`${CLOUD_LICENSING_PAGE_PATH}/on-prem-devices`}
      legend={breakdown.items}
    >
      {breakdown.items.length === 0 ? (
        <NoBreakdownData />
      ) : (
        <DeviceTypeBreakdownChart breakdown={breakdown} unit='devices' />
      )}
    </BreakdownSection>
  );
};
